
export function isgValidatorDropDownNoValidation (value: string, callback: (value: boolean) => void) {
  callback(true);
};
